import { render, staticRenderFns } from "./RenderPdf.vue?vue&type=template&id=2e368438"
import script from "./RenderPdf.vue?vue&type=script&lang=js"
export * from "./RenderPdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2296946445/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e368438')) {
      api.createRecord('2e368438', component.options)
    } else {
      api.reload('2e368438', component.options)
    }
    module.hot.accept("./RenderPdf.vue?vue&type=template&id=2e368438", function () {
      api.rerender('2e368438', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/files/RenderPdf.vue"
export default component.exports